import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/form/index.js
// module id = 667
// module chunks = 0